import { VariableValue } from '@components/Variables/types'

export const getVariablesHint = (variables?: VariableValue[]) => {
  if (!variables?.length) {
    return {}
  }

  return variables.reduce(
    (result, nextItem) => ({
      ...result,
      [nextItem.internalId]: {
        valueType: nextItem.valueType,
        variableType: nextItem.variableType,
        defaultValue: 'any',
      },
    }),
    {}
  )
}
